import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { site } from '@panel/commons/helpers';
import { selectBillingInfo, selectCurrentTaxCondition } from '../../../../../../ducks/step4Module2';
import { ReadOnlyContainer, Title } from '../../../styles';

const ReadOnlySubTitle = ({ text }) => {
  const mailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/;
  const subtitleArr = text.split(mailRegex);

  return (
    <Title subtitle>
      {subtitleArr[0]}
      <span>{subtitleArr[1]}</span>
      {subtitleArr[2]}
    </Title>
  );
};

function BillingReadOnly() {
  const billingInfo = useSelector(selectBillingInfo);
  const taxInfo = useSelector(selectCurrentTaxCondition);
  const { t } = useTranslation();

  const billingInfoData = useMemo(() => {
    if (Object.keys(billingInfo).length === 0) {
      return {};
    }
    return {
      userName: billingInfo?.legalName,
      userTaxCondition: (site.isArgentina || site.isMexico) && taxInfo?.taxCondition ? taxInfo?.taxCondition : null,
      taxId: billingInfo?.taxId && taxInfo?.taxCondition ? billingInfo?.taxId : null,
      address: !site.isArgentina && !site.isMexico ? billingInfo?.address : null,
      postalCode: site.isBrasil ? billingInfo?.postalCode : null
    };
  }, [billingInfo, taxInfo]);

  return (
    <>
      <ReadOnlySubTitle text={t('publisher.step4.module2.billingRO.subtitle')} />
      <ReadOnlyContainer>
        {Object.keys(billingInfoData).map(
          key =>
            billingInfoData[key] && (
              <div key={key}>
                {`${key === 'taxId' ? 'DNI' : t(`publisher.step4.module2.field.${key}.label`)}: ${
                  billingInfoData[key]
                }`}
              </div>
            )
        )}
      </ReadOnlyContainer>
    </>
  );
}

export default BillingReadOnly;
